import { marginBottom } from "../App";
import { useState, useEffect, useContext } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { TextField, FormControl } from "@mui/material";
import Button from "@mui/material/Button";
import { UserDataContext } from "../components/UserDataContext";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import { regex } from "../utils/regex";
import Alerts from "../components/Alerts";
import { useNavigate } from "react-router-dom";
import VN from "../components/VN";
import { apiRequest } from "../components/Config";

export default function PassChange({ userId }) {
  const [showApiResponse, setShowApiResponse] = useState(false);
  const [apiResponse, setApiResponse] = useState({});
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [repeatNewPassword, setRepeatNewPassword] = useState("");
  const [error, setError] = useState("");
  const { userData, setUserData } = useContext(UserDataContext);
  const navigate = useNavigate();

  const handleLogout = async () => {
    setUserData({
      userId: 0,
      user: "",
      permId: "0",
      fullName: "",
      grpName: "",
      description: "",
      is_active: "0",
      phone: "",
      idGrp: "0",
    });

    try {
      const response = await apiRequest("logout", "POST");
      //console.log(response);
    } catch (error) {
      console.error(error);
    }
    navigate("/login");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      repeatNewPassword === newPassword &&
      newPassword.length >= 8 &&
      regex.test(newPassword)
    ) {
      try {
        const response = await apiRequest("passchange", "POST", {
          userId: userId,
          oldpassword: oldPassword,
          newpassword: newPassword,
          repeatnewpassword: repeatNewPassword,
        });
        setError(response.error_msg);
        //console.log("PassChange: ", response);
      } catch (error) {
        setApiResponse({
          title: "Błąd",
          severity: "error",
          info: "Wystąpił błąd.",
        });
        console.error(error);
        setShowApiResponse(true);
      }
    } else {
      setApiResponse({
        title: "Błąd",
        severity: "error",
        info: "Hasło powinno mieć min. 8 znaków, dużą literę i znak specjalny",
      });
      setShowApiResponse(true);
      setNewPassword("");
      setRepeatNewPassword("");
      return;
    }
  };

  useEffect(() => {
    if (userId === userData.userId) {
      setShowOldPassword(true);
    } else {
      setShowOldPassword(false);
    }
  }, [userId, userData.userId]);

  useEffect(() => {
    if (error === 200) {
      setApiResponse({
        title: "Informacja",
        severity: "success",
        info: "Hasło użytkownika zostało zmienione.",
      });
      setShowApiResponse(true);
    }
  }, [error]);

  useEffect(() => {
    if (userId === userData.userId && error === 200) {
      setApiResponse({
        title: "Błąd",
        severity: "success",
        info: "Hasło zostało zmienione. Zaloguj się z nowym hasłem",
      });
      const timeoutId = setTimeout(() => {
        handleLogout(navigate);
      }, 5000);
      return () => clearTimeout(timeoutId);
    }

    if (userId === userData.userId && error === 250) {
      setApiResponse({
        title: "Błąd",
        severity: "error",
        info: "Hasło nie zostało zmienione. Prawdopodobnie nie podano właściwego aktualnego hasła. Sprawdź, czy nie masz włączonego Caps Locka",
      });
      setShowApiResponse(true);
    }
  }, [error, navigate, userData.userId, userId, newPassword]);

  return (
    <div>
      <VN userData={userData} />
      {showApiResponse && (
        <Row style={{ marginBottom }}>
          <Alerts data={apiResponse} />
        </Row>
      )}
      <ThemeProvider theme={theme}>
        <Container>
          {showOldPassword && (
            <Row style={{ marginBottom }}>
              <Col>
                <FormControl fullWidth>
                  <TextField
                    label="Dotychczasowe hasło"
                    type="password"
                    variant="outlined"
                    value={oldPassword || ""}
                    onChange={(e) => setOldPassword(e.target.value)}
                    fullWidth
                  />
                </FormControl>
              </Col>
            </Row>
          )}
          <Form>
            <Row style={{ marginBottom }}>
              <Col>
                <FormControl fullWidth>
                  <TextField
                    label="Nowe hasło"
                    type="password"
                    variant="outlined"
                    value={newPassword || ""}
                    onChange={(e) => setNewPassword(e.target.value)}
                    fullWidth
                  />
                </FormControl>
              </Col>
            </Row>

            <Row style={{ marginBottom }}>
              <Col>
                <FormControl fullWidth>
                  <TextField
                    label="Powtórz nowe hasło"
                    type="password"
                    variant="outlined"
                    value={repeatNewPassword || ""}
                    onChange={(e) => setRepeatNewPassword(e.target.value)}
                    fullWidth
                  />
                </FormControl>
              </Col>
            </Row>

            <Row>
              <Col>
                <Button variant="contained" onClick={handleSubmit}>
                  Zmień hasło
                </Button>
              </Col>
            </Row>
          </Form>
        </Container>
      </ThemeProvider>
    </div>
  );
}
